/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductsStandardsQueryResponse,
  FindProductsStandardsQueryParams,
} from "../types/FindProductsStandards.ts"

export const findProductsStandardsQueryKey = (
  params: FindProductsStandardsQueryParams
) =>
  [
    { url: "/v1/product/find-products-standards" },
    ...(params ? [params] : []),
  ] as const

export type FindProductsStandardsQueryKey = ReturnType<
  typeof findProductsStandardsQueryKey
>

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-standards}
 */
export async function findProductsStandards(
  params: FindProductsStandardsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductsStandardsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-products-standards`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductsStandardsQueryOptions(
  params: FindProductsStandardsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductsStandardsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductsStandardsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductsStandardsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductsStandards(params, config)
    },
  })
}

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-standards}
 */
export function useFindProductsStandards<
  TData = ResponseConfig<FindProductsStandardsQueryResponse>,
  TQueryData = ResponseConfig<FindProductsStandardsQueryResponse>,
  TQueryKey extends QueryKey = FindProductsStandardsQueryKey,
>(
  params: FindProductsStandardsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductsStandardsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductsStandardsQueryKey(params)

  const query = useQuery(
    {
      ...findProductsStandardsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
